var exports = {
  "i": "xcc377c0b--034561--wrapper",
};

module.exports = exports;
